import React from "react";
import moment from "moment";
import SoarCard from "./SoarCard";
import FieldDisplay from "../common/FieldDisplay";
import {
  getFieldText,
  getFieldName,
  getFieldDate,
  getFieldFormattedValue,
} from "../../scripts/helperScripts";

function RecordedServiceCard({ service, encounter, notes }) {
  return (
    <SoarCard
      title={service.ccx_name}
      path={`/main.aspx?etc=10162&extraqs=formid%3d04c8adb0-2554-4944-8d6a-38e30ce24a0e&id=${service.ccx_recorded_serviceid}&pagetype=entityrecord`}
      body={
        <div key={service.ccx_recorded_serviceid}>
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2 mb-4">
            <div className="col">
              <FieldDisplay
                label="Start Time:"
                value={
                  service.ccx_starttime &&
                  new Date(getFieldText(service.ccx_starttime)).toLocaleString()
                }
              />
              <FieldDisplay
                label="End Time:"
                value={
                  service.ccx_endtime &&
                  new Date(getFieldText(service.ccx_endtime)).toLocaleString()
                }
              />
              <FieldDisplay
                label="Minutes:"
                value={getFieldFormattedValue(service.ccx_minutes)}
              />
              <FieldDisplay
                label="Units:"
                value={getFieldFormattedValue(service.ccx_units)}
              />
              {service.ccx_clientdiagnosis !== undefined ? (
                <FieldDisplay
                  label="Diagnosis:"
                  value={getFieldName(service.ccx_clientdiagnosis)}
                />
              ) : null}
            </div>
            <div className="col">
              <FieldDisplay
                label="Provider"
                value={getFieldName(service.ccx_caregiver)}
              />
              <FieldDisplay
                label="Service Item"
                value={getFieldName(service.ccx_serviceitem)}
              />
              <FieldDisplay
                label="Service Status"
                value={getFieldName(service.ccx_servicestatuslookup)}
              />
              <FieldDisplay
                label="Place of Service:"
                value={getFieldName(service.ccx_placeofservice)}
              />
              <FieldDisplay
                label="Delivery Method"
                value={getFieldName(service.ccx_deliverymethod)}
              />
            </div>
          </div>
          {notes && notes.length > 0 && (
            <>
              <div className="h6 pb-0">Progress Notes</div>
              <div
                className="p-2 mb-4 w-100 h-100"
                style={{ backgroundColor: "white", whiteSpace: "pre-wrap" }}
              >
                {notes.map((note) => (
                  <div
                    key={`${service.ccx_recorded_serviceid}.note.${note.ccx_progress_noteid}`}
                  >
                    <p>{note["ccx_note"]}</p>
                    {!service.ccx_encounter ? (
                      <>
                        <FieldDisplay
                          label="eSign User:"
                          value={getFieldName(note.ccx_esignuser)}
                        />
                        <FieldDisplay
                          label="Signed:"
                          value={getFieldDate(note.ccx_esigndatetime)}
                        />
                      </>
                    ) : null}
                  </div>
                ))}
              </div>
            </>
          )}
          {encounter ? (
            <>
              {encounter.ccx_draftsigneduser && (
                <FieldDisplay
                  label="Draft Signed User:"
                  value={getFieldName(encounter.ccx_draftsigneduser)}
                />
              )}
              {encounter.ccx_draftsigneddate && (
                <FieldDisplay
                  label="Draft Signed Date:"
                  value={`${moment(
                    getFieldText(encounter.ccx_draftsigneddate)
                  ).format("L")}`}
                />
              )}
            </>
          ) : null}
          <FieldDisplay
            label="eSign User:"
            value={getFieldName(service.ccx_esignuser)}
          />
          <FieldDisplay
            label="Signed:"
            value={getFieldDate(service.ccx_esigndate)}
          />
        </div>
      }
    />
  );
}

export default RecordedServiceCard;

// /main.aspx?etc=10162&extraqs=formid%3d04c8adb0-2554-4944-8d6a-38e30ce24a0e&id=%7b4BA2058B-52ED-EA11-84EE-000C29F4947D%7d&pagetype=entityrecord
